import styles from "./styles.module.scss";

interface AspectImproveData {
  steps: string[];
  improvementValue: string;
  score: number;
}

interface AspectImproveProps {
  aspectImprove: AspectImproveData[];
  activeIndex: number;
}

export const AspectImprove = ({
  aspectImprove,
  activeIndex,
}: AspectImproveProps) => {
  const activeData = aspectImprove[activeIndex];

  if (!activeData) {
    return <div className={styles.empty}>No data available</div>;
  }

  return (
    <div className={styles.box}>
      <h2>Steps to improve review score</h2>
    </div>
  );
};
